import create from 'zustand'
import produce from 'immer'
import { persist } from 'zustand/middleware'
import { setCookie } from 'cookies-next'
import { sessionKeyName } from '../helpers/api'

export const logoutCookie = () => {
    setCookie(sessionKeyName, '', { expires: new Date(0) })
}

export const UserStore = create(
    persist(
        (set) => ({
            user: {},
            save: (user) => {
                set(
                    produce((draft) => {
                        draft.user = user
                    }),
                )
            },
            updateCustomer: (customer) => {
                set(
                    produce((draft) => {
                        draft.user.customer = customer
                    }),
                )
            },
            updateOrders: (orders) => {
                set(
                    produce((draft) => {
                        draft.user.orders = orders
                    }),
                )
            },
            logout: () => {
                set(
                    produce((draft) => {
                        draft.user = {}
                    }),
                )
            },
        }),
        {
            name: `olm-user-${process.env.NEXT_PUBLIC_STORE_SUFFIX}`,
        },
    ),
)
